<template>
  <div class="flexRow">
    <div class="currentSummary" v-if="displaySummary">
      {{ numCompleted }}
    </div>
    <block-row
      :blocks="blocks"
      :category="category"
      :color="color"
      :categoryId="categoryId"
      :quota="quota"
      :isContinuous="isContinuous"
      :customDate="customDate"
    />
    <!-- INCLUDE QUOTA BLOCKS -->
  </div>
</template>

<script>
import BlockRow from "./BlockRow.vue";

export default {
  name: "current-blocks",
  components: {
    "block-row": BlockRow,
  },
  props: {
    blocks: Object,
    quota: Number,
    category: String,
    color: String,
    categoryId: String,
    displaySummary: {
      type: Boolean,
      default: false,
    },
    isContinuous: {
      type: Boolean,
      default: false,
    },
    customDate: {
      type: String,
      default: "",
    },
  },
  computed: {
    numCompleted() {
      return this.blocks ? Object.keys(this.blocks).length : 0;
    },
  },
};
</script>

<style scoped>
/* FIXME - Sync this with styles from pastBlocks*/
.currentSummary {
  display: inline-block;
  padding: 1.25rem 1rem;
  width: 1.5rem;
  border-left: 1px solid #777;
  border-right: 1px solid #777;
}

@media (max-width: 600px) {
  .blockRow {
    padding: 0.25rem;
  }

  .blockRow .block {
    height: 1.5rem;
    width: 1.5rem;
  }
}
</style>



// WEBPACK FOOTER //
// CurrentBlocks.vue?44030de4